











































import {
  Configuration,
  PaymentOverview,
  ConferenceDetail,
  DoctorPaymentRestControllerApi,
  ConferenceDetailRestControllerApi,
} from '@/types/api-docs'
import Utils from '@/utils/utils'
import { DataOptions, DataTableHeader } from 'vuetify'
import Vue from 'vue'

const paymentApi = new DoctorPaymentRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))
const conferenceApi = new ConferenceDetailRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  overviews?: PaymentOverview[]
  conference?: ConferenceDetail
  total?: number
  loading: boolean
  options: DataOptions
  headers: DataTableHeader[]
}

export default Vue.extend({
  components: {},
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      overviews: [],
      conference: undefined,
      total: 0,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ['fiscalYear'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      headers: [
        { text: 'No', value: 'id', width: '7%' },
        { text: '年度', value: 'fiscalYear', width: '7%' },
        { text: '請求名', value: 'paymentContent', width: '30%' },
        { text: '請求額', value: 'billAmount', width: '8%' },
        { text: '支払額', value: 'paymentAmount', width: '8%' },
        { text: '支払方法', value: 'paymentType', width: '9%' },
        { text: '支払日', value: 'paymentDate', width: '9%' },
        { text: '', value: 'action', sortable: false, width: '13%' },
        { text: '', value: 'receipt', sortable: false, width: '9%' },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  computed: {},
  async mounted() {
    await this.fetchConference()
  },
  methods: {
    async fetchConference() {
      const { data } = await conferenceApi.fetchConference()
      this.conference = data
    },
    async getDataFromApi() {
      this.loading = true
      const { data } = await paymentApi.fetchEtcPaymentOverviews(
        this.options.page - 1,
        this.options.itemsPerPage,
        Utils.parseSortQueryParams(this.options)
      )
      this.overviews = data.content
      this.total = data.totalElements
      this.loading = false
      if (data.totalPages && this.options.page > data.totalPages) {
        this.options.page = data.totalPages
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gotoPaymentPage(item: any) {
      this.$router.push(`/member/payments/etcs/${item.id}`)
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gotoReceiptPage(item: any) {
      this.$router.push(`/member/payments/etcs/${item.id}/receipt`)
    },
    gotoInvoicePage(item: any) {
      this.$router.push(`/member/payments/etcs/${item.id}/invoice`)
    },
  },
})
